import { render, staticRenderFns } from "./CreateMailSender.vue?vue&type=template&id=1ee851ba&scoped=true"
import script from "./CreateMailSender.vue?vue&type=script&lang=js"
export * from "./CreateMailSender.vue?vue&type=script&lang=js"
import style0 from "./CreateMailSender.vue?vue&type=style&index=0&id=1ee851ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee851ba",
  null
  
)

export default component.exports